export default __webpack_public_path__ + "static/media/Attendance_filled.8a00485e.svg";